import { render, staticRenderFns } from "./psc-box2.vue?vue&type=template&id=2474c890&scoped=true&"
import script from "./psc-box2.vue?vue&type=script&lang=js&"
export * from "./psc-box2.vue?vue&type=script&lang=js&"
import style0 from "./psc-box2.vue?vue&type=style&index=0&id=2474c890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474c890",
  null
  
)

export default component.exports